@if(followUps && followUps.length > 0) {
<div class="mb-2 flex flex-col gap-2">
    <span class="text-sm text-gray-700">Suggested follow-ups</span>
    <div class="flex flex-col gap-1">
        @for(followUp of followUps; track $index) {
        <div class="border-b pb-1">
            <div class="flex items-center justify-between gap-3 p-2 text-left hover:bg-gray-100 hover:cursor-pointer hover:rounded-lg  border-gray-200 "
                (click)="handleFollowUpClick(followUp)">
                <div class="flex items-start gap-3 flex-1 min-w-0">
                    <span class="text-sm text-gray-700 group-hover:text-gray-900 flex-1 leading-relaxed">{{ followUp
                        }}</span>
                </div>
                <div>
                    <app-icon type="pi pi-arrow-right" [source]="IconSourceEnum.PRIMENG"
                        class="text-gray-400"></app-icon>
                </div>
            </div>
        </div>
        }
    </div>
</div>
}
